import React from 'react'

const Resume = () => {
  return (
    <div>
        <iframe src='KoushikMB_SWE.pdf' className='w-lvw h-lvh' title='Koushik_MB_Resume' />
    </div>
  )
}

export default Resume